



















































































import * as $rdf from 'rdflib'
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import FormInput from '@/components/ShaclForm/FormInput.vue'
import fieldUtils from '@/components/ShaclForm/fieldUtils'
import { ValidationReport } from '@/components/ShaclForm/Parser/ValidationReport'
import { SHACL } from '@/rdf/namespaces'

@Component({
  name: 'FormRenderer',
  components: { FormInput },
})
export default class FormRenderer extends Vue {
  @Prop({ required: true })
  readonly definition: any

  @Prop({ required: false, default: () => $rdf.blankNode(null) })
  readonly subject: any

  @Prop({ required: true })
  readonly validationReport: ValidationReport

  @Prop({ required: true })
    value: any

  data: any

  componentKey: number = 0

  dirtyFields: Set<string>

  wrapNodeShape(nodeShape) {
    return {
      groups: [{
        fields: nodeShape.fields,
        isReal: false,
      }],
      targetClasses: nodeShape.targetClasses,
    }
  }

  createDefaultValue(field) {
    if (field.nodeShape) {
      return {
        subject: $rdf.blankNode(null),
        data: {},
      }
    }

    return ''
  }

  createDefaultValueArray(field) {
    if (field.minCount === 1 || (field.maxCount === 1 && !fieldUtils.isOptionalNode(field))) {
      return [this.createDefaultValue(field)]
    }

    return []
  }

  created(): void {
    this.dirtyFields = new Set<string>()
    this.data = this.definition.groups.reduce((acc, group) => {
      group.fields.forEach((field) => {
        acc[field.path] = _.get(this.value.data, field.path, this.createDefaultValueArray(field))
      })
      return acc
    }, {})
    this.onInput()
  }

  getName(field) {
    return fieldUtils.getName(field)
  }

  isRequired(field) {
    return fieldUtils.isRequired(field)
  }

  isList(field) {
    return fieldUtils.isList(field) || fieldUtils.isOptionalNode(field)
  }

  canBeRemoved(field) {
    const count = this.data[field.path].length
    const minCount = _.get(field, 'minCount', 0)
    return this.isList(field) && count > minCount
  }

  canAddValue(field) {
    const count = this.data[field.path].length
    const maxCount: number | null = _.get(field, 'maxCount', null)
    return maxCount === null || count < maxCount
  }

  addValue(field) {
    this.data[field.path].push(this.createDefaultValue(field))
  }

  removeValue(field, index) {
    this.data[field.path].splice(index, 1)
    this.componentKey += 1
    this.onInput(field)
  }

  isDirty(field) {
    return this.dirtyFields.has(field.path)
  }

  cleanDirty() {
    this.dirtyFields = new Set<string>()
  }

  getError(field) {
    if (this.isDirty(field)) {
      return this.getLocalError(field)
    }
    const subject = `${this.subject}`
    if (_.has(this.validationReport, subject)) {
      return this.humanReadableError(field, this.validationReport[subject][field.path])
    }

    return null
  }

  getLocalError(field) {
    const valueString = _.get(this.data[field.path], '0.value', `${this.data[field.path]}`)

    if (valueString === null) {
      return null
    }

    const values = valueString.split(',')
    for (let i = 0; i < values.length; i += 1) {
      const value = values[i]

      if (field.minLength && value.length < field.minLength) {
        return `${this.getName(field)} should be at least ${field.minLength} characters.`
      }

      if (field.maxLength && value.length > field.maxLength) {
        return `${this.getName(field)} should be at most ${field.maxLength} characters.`
      }

      if (field.in && field.in.indexOf(value) === -1) {
        return `${this.getName(field)} should contain one of the values: ${field.in.join(', ')}.`
      }
    }

    return null
  }

  humanReadableError(field, originalError) {
    switch (originalError) {
      case SHACL('MinCountConstraintComponent').value:
        return `${this.getName(field)} is required.`

      case SHACL('NodeKindConstraintComponent').value:
        return `${this.getName(field)} requires a valid IRI.`

      case SHACL('MinLengthConstraintComponent').value:
        return `${this.getName(field)} should be at least ${field.minLength} characters.`

      case SHACL('MaxLengthConstraintComponent').value:
        return `${this.getName(field)} should be at most ${field.maxLength} characters.`

      case SHACL('InConstraintComponent').value:
        return `${this.getName(field)} should contain one of the values: ${field.in.join(', ')}.`

      default:
        return originalError
    }
  }

  onInput(field = null) {
    if (field) {
      this.dirtyFields.add(field.path)
    }

    this.$emit('input', {
      subject: this.value.subject,
      data: this.data,
      targetClasses: this.definition.targetClasses,
    })
  }
}

